const CHART_SELECTOR = ".js-chart";

function init(): void {
  if (document.querySelector(CHART_SELECTOR) !== null) {
    // If a chart block exists

    const head = document.getElementsByTagName("head")[0];

    const js = document.createElement("script");

    // Default fallback when global-v3.js script is unavailable
    let version = `?v=${new Date().getTime()}`;

    const scripts = document.querySelectorAll('script');
    const targetScript = Array.from(scripts).find(script =>
      script.src.includes('/scripts/global-v3.js')
    );

    if (targetScript) {
      // If global-v3.js is available, get cache burst param from it and assign to amcharts.js scripts
      const versionIndex = targetScript.src.indexOf('?v=')

      version = targetScript.src.slice(versionIndex);
    }

    js.src = `/scripts/amcharts.js${version}`;

    head.appendChild(js);
  }
}

export default {init};
